<template>
    <div class="questionquery">
        <el-row type="flex" class="row-bg field" justify="center">
            <el-col :span="9" class="position">
                <el-input
                    v-model="quest"
                    placeholder="请输入要查询的内容"
                ></el-input>
                <i @click="searchquery()" class="el-icon-search"></i>
            </el-col>
        </el-row>
        <!-- <div class="way">
            <el-row type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item
                            :to="{
                                path: '/',
                                query: {
                                    id: '97AAB3AA-0B0C-D385-B987-2BA46580D87B'
                                }
                            }"
                            >首页</el-breadcrumb-item
                        >
                        <el-breadcrumb-item>帮助中心</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="20">
                <el-collapse
                    v-model="activeNames"
                    @change="handleChange"
                    accordion
                >
                    <el-collapse-item
                        v-for="(item, index) in mainlist"
                        :key="index"
                        :title="item.title"
                        :name="index"
                    >
                        <div v-html="item.content"></div>
                    </el-collapse-item>
                </el-collapse>
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="ruleForm.pageIndex"
                    :page-size="ruleForm.pageSize"
                    layout="total,prev, pager, next"
                    :total="ruleForm.total"
                >
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { selectfaq } from "@/api/homePage";
import Bus from "@/utils/bus";
export default {
    name: "questionquery",
    data() {
        return {
            quest: "",
            activeNames: [0],
            mainlist: [],
            ruleForm: {
                data: {
                    title: "",
                    platform: "1"
                },
                pageIndex: 1,
                pageSize: 5,
                total: 0
            }
        };
    },
    created() {
        this.quest = this.$route.query.search;
        this.search(1);
    },
    watch: {
        $route(to, from) {
            this.search(1);
        }
    },
    methods: {
        questionquery() {},
        handleChange() {},
        searchquery() {
            this.$router.push({
                path: this.$route.path,
                query: {
                    id: this.$route.query.id,
                    search: this.quest
                }
            });
        },
        search(val) {
            this.ruleForm.pageIndex = val;
            this.ruleForm.data.title = this.quest;
            // this.$route.query.search = this.quest;
            selectfaq(this.ruleForm).then(res => {
                if (res.status === 2000) {
                    this.mainlist = res.data.rows;
                    this.ruleForm.total = res.data.total;
                }
            });
        },
        handleCurrentChange(val) {
            this.search(val);
        }
    }
};
</script>
<style lang="scss" scoped>
.questionquery {
    .field {
        position: relative;
        .position {
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 9;
            .el-input {
                width: 100%;
                /deep/ .el-input__inner {
                    border-radius: 20px;
                    background-color: rgba(255, 255, 255, 0.9);
                    color: #000;
                }
            }
            .el-icon-search {
                cursor: pointer;
                font-size: 26px;
                color: #fabe00;
                position: absolute;
                top: 7px;
                right: 16px;
            }
        }
    }
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        /deep/ .el-breadcrumb {
            line-height: 50px;
            .el-breadcrumb__item {
                line-height: 46px;
            }
            .el-breadcrumb__inner {
                font-weight: bold;
                color: #ffffff;
            }
        }
    }
    .main {
        height: 200px;
    }
    .el-pagination {
        text-align: center;
        margin-top: 30px;
        margin-bottom: 60px;
    }
    /deep/ .el-pagination.is-background .el-pager li {
        border-radius: 15px;
    }
    /deep/ .el-pagination.is-background .btn-prev,
    /deep/ .el-pagination.is-background .btn-next {
        border-radius: 15px;
    }
}
</style>
